// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InvoicePreview_invoiceCard__f6l7j {
  background: #fff;
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.05);
  max-width: 100%;
  margin: auto;
  font-family: "Inter", sans-serif;
  color: #111827;
}

.InvoicePreview_header__Et1ZA {
  background: #7ba1b0;
  color: #fff;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.InvoicePreview_header__Et1ZA h2 {
  font: var(--h5);
  font-weight: 700;
  margin: 0;
}
.InvoicePreview_header__Et1ZA .InvoicePreview_invoiceInfo__zEENU {
  text-align: right;
  font: var(--body-font-four);
  line-height: 1.5;
}

.InvoicePreview_infoSection__BO4FR {
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
}
.InvoicePreview_infoSection__BO4FR .InvoicePreview_infoSectionHead__0V-W2 {
  display: flex;
  flex-direction: column;
}
.InvoicePreview_infoSection__BO4FR .InvoicePreview_infoSectionHead__0V-W2.InvoicePreview_from__6wbcf {
  gap: 4px;
  align-items: flex-start;
}
.InvoicePreview_infoSection__BO4FR .InvoicePreview_infoSectionHead__0V-W2.InvoicePreview_billTo__pwLmR {
  gap: 8px;
  align-items: flex-end;
}
.InvoicePreview_infoSection__BO4FR h4 {
  font: var(--body-font-two);
  font-weight: 600;
}
.InvoicePreview_infoSection__BO4FR p {
  font: var(--body-font-three);
}
.InvoicePreview_infoSection__BO4FR .InvoicePreview_pendingDot__8LrKb {
  width: 8px;
  height: 8px;
  background: #f59e0b;
  border-radius: 50%;
}

.InvoicePreview_table__Zs-CP {
  width: 100%;
  border-collapse: collapse;
  min-width: 400px;
}
.InvoicePreview_table__Zs-CP thead {
  border-bottom: 1px solid var(--border);
}
.InvoicePreview_table__Zs-CP th {
  text-align: left;
  font-weight: 500;
  font: var(--body-font-three);
  color: #111827;
  padding: 16px 0;
  text-align: right;
}
.InvoicePreview_table__Zs-CP th:first-child {
  text-align: left;
}
.InvoicePreview_table__Zs-CP td {
  padding-top: 16px;
  font: var(--body-font-three);
  color: #374151;
  text-align: right;
}
.InvoicePreview_table__Zs-CP td:first-child {
  text-align: left;
}

.InvoicePreview_totals__jRbch {
  display: flex;
  justify-content: flex-end;
  gap: 40px;
  border-top: 1px solid var(--border);
  margin-top: 16px;
  padding-top: 16px;
}
.InvoicePreview_totals__jRbch div {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.InvoicePreview_totals__jRbch p,
.InvoicePreview_totals__jRbch h4 {
  margin: 4px 0;
  text-align: right;
  font: var(--body-font-three);
}
.InvoicePreview_totals__jRbch h4 {
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/InvoicePreview/InvoicePreview.module.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,YAAA;EACA,gCAAA;EACA,cAAA;AACJ;;AAEA;EACI,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;AACJ;AACI;EACI,eAAA;EACA,gBAAA;EACA,SAAA;AACR;AAEI;EACI,iBAAA;EACA,2BAAA;EACA,gBAAA;AAAR;;AAIA;EACI,aAAA;EACA,8BAAA;EACA,eAAA;AADJ;AAGI;EACI,aAAA;EACA,sBAAA;AADR;AAGQ;EACI,QAAA;EACA,uBAAA;AADZ;AAIQ;EACI,QAAA;EACA,qBAAA;AAFZ;AAMI;EACI,0BAAA;EACA,gBAAA;AAJR;AAOI;EACI,4BAAA;AALR;AAQI;EACI,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AANR;;AAUA;EACI,WAAA;EACA,yBAAA;EACA,gBAAA;AAPJ;AASI;EACI,sCAAA;AAPR;AAUI;EACI,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AARR;AAUQ;EACI,gBAAA;AARZ;AAYI;EACI,iBAAA;EACA,4BAAA;EACA,cAAA;EACA,iBAAA;AAVR;AAYQ;EACI,gBAAA;AAVZ;;AAeA;EACI,aAAA;EACA,yBAAA;EACA,SAAA;EACA,mCAAA;EACA,gBAAA;EACA,iBAAA;AAZJ;AAcI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAZR;AAeI;;EAEI,aAAA;EACA,iBAAA;EACA,4BAAA;AAbR;AAgBI;EACI,gBAAA;AAdR","sourcesContent":[".invoiceCard {\r\n    background: #fff;\r\n    border-radius: 10px;\r\n    padding: 16px;\r\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.05);\r\n    max-width: 100%;\r\n    margin: auto;\r\n    font-family: 'Inter', sans-serif;\r\n    color: #111827;\r\n}\r\n\r\n.header {\r\n    background: #7ba1b0;\r\n    color: #fff;\r\n    border-radius: 8px;\r\n    padding: 16px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n\r\n    h2 {\r\n        font: var(--h5);\r\n        font-weight: 700;\r\n        margin: 0;\r\n    }\r\n\r\n    .invoiceInfo {\r\n        text-align: right;\r\n        font: var(--body-font-four);\r\n        line-height: 1.5;\r\n    }\r\n}\r\n\r\n.infoSection {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 20px 0;\r\n\r\n    .infoSectionHead {\r\n        display: flex;\r\n        flex-direction: column;\r\n\r\n        &.from {\r\n            gap: 4px;\r\n            align-items: flex-start;\r\n        }\r\n\r\n        &.billTo {\r\n            gap: 8px;\r\n            align-items: flex-end;\r\n        }\r\n    }\r\n\r\n    h4 {\r\n        font: var(--body-font-two);\r\n        font-weight: 600;\r\n    }\r\n\r\n    p {\r\n        font: var(--body-font-three);\r\n    }\r\n\r\n    .pendingDot {\r\n        width: 8px;\r\n        height: 8px;\r\n        background: #f59e0b;\r\n        border-radius: 50%;\r\n    }\r\n}\r\n\r\n.table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    min-width: 400px;\r\n\r\n    thead {\r\n        border-bottom: 1px solid var(--border);\r\n    }\r\n\r\n    th {\r\n        text-align: left;\r\n        font-weight: 500;\r\n        font: var(--body-font-three);\r\n        color: #111827;\r\n        padding: 16px 0;\r\n        text-align: right;\r\n\r\n        &:first-child {\r\n            text-align: left;\r\n        }\r\n    }\r\n\r\n    td {\r\n        padding-top: 16px;\r\n        font: var(--body-font-three);\r\n        color: #374151;\r\n        text-align: right;\r\n\r\n        &:first-child {\r\n            text-align: left;\r\n        }\r\n    }\r\n}\r\n\r\n.totals {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 40px;\r\n    border-top: 1px solid var(--border);\r\n    margin-top: 16px;\r\n    padding-top: 16px;\r\n\r\n    div {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 12px;\r\n    }\r\n\r\n    p,\r\n    h4 {\r\n        margin: 4px 0;\r\n        text-align: right;\r\n        font: var(--body-font-three);\r\n    }\r\n\r\n    h4 {\r\n        font-weight: 600;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"invoiceCard": `InvoicePreview_invoiceCard__f6l7j`,
	"header": `InvoicePreview_header__Et1ZA`,
	"invoiceInfo": `InvoicePreview_invoiceInfo__zEENU`,
	"infoSection": `InvoicePreview_infoSection__BO4FR`,
	"infoSectionHead": `InvoicePreview_infoSectionHead__0V-W2`,
	"from": `InvoicePreview_from__6wbcf`,
	"billTo": `InvoicePreview_billTo__pwLmR`,
	"pendingDot": `InvoicePreview_pendingDot__8LrKb`,
	"table": `InvoicePreview_table__Zs-CP`,
	"totals": `InvoicePreview_totals__jRbch`
};
export default ___CSS_LOADER_EXPORT___;
